export default __webpack_public_path__ + "static/media/Dead Sea Scrolls - All Souls Deuteronomy_03.d16484fa.jpg";